import { Api } from '../api';
import {
  ICreateGrupoTeste, ICreateGrupoTesteDestinatario, IListagemGrupoTeste,
  IListagemGrupoTesteDestinatario, IResponseGrupoTesteDestinatario,
  IResponseGrupoTesteLog, IResponseGrupoTesteDestinatarioLog
} from 'shared/types/grupoTeste';


const getAll = async (org: number, filter = ''): Promise<IResponseGrupoTesteLog | Error> => {
  try {
    const { data, status } = await Api.get(`/Org/${org}/GrupoTesteLog/${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllLogDestinatario = async ( filter = ''): Promise<IResponseGrupoTesteDestinatarioLog | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/GrupoTesteDestinatarioLog/grupotestedestinatario/${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data.retornoPagina;
    }
    if (status === 204) {
      return { rows:[], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (org: number, canal: number, id: number): Promise<IListagemGrupoTeste | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (org: number, canal: number, dados: ICreateGrupoTeste): Promise<string | Error> => {
  try {
    const { data, status } = await Api.post(`/Orgs/${org}/Canais/${canal}/GrupoTeste`, dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data.idGrupoTeste;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (org: number, canal: number, id: number, dados: ICreateGrupoTeste,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const deleteById = async (org: number, canal: number, id: number): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const getAutoComplete = async (filter = ''): Promise<ICreateGrupoTeste[] | Error> => {
  try {
    const { data, status } = await Api.get(`/GrupoTesteSeed/autocomplete${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllDestinatario = async (org: number, canal: number, grupoTeste: number, filter = ''): Promise<IResponseGrupoTesteDestinatario | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${grupoTeste}/Destinatario${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return { rows: [], count: 0 };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getDestinatarioById = async (org: number, canal: number, grupoTeste: number, id: number): Promise<IListagemGrupoTesteDestinatario | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${grupoTeste}/Destinatario/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};


const createDestinatario = async (org: number, canal: number, grupoTeste: number, dados: ICreateGrupoTesteDestinatario): Promise<string | Error> => {
  try {
    const { data, status } = await Api.post(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${grupoTeste}/Destinatario`, dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data.idDestinatario;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateDestinatarioById = async (org: number, canal: number, grupoTeste: number, id: number, dados: ICreateGrupoTesteDestinatario,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${grupoTeste}/Destinatario/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};


const deleteDestinatarioById = async (org: number, canal: number, grupoTeste: number, id: number): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${org}/Canais/${canal}/GrupoTeste/${grupoTeste}/Destinatario/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

export const logService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAutoComplete,
  getAllDestinatario,
  createDestinatario,
  getDestinatarioById,
  updateDestinatarioById,
  deleteDestinatarioById,
  getAllLogDestinatario,
};
